import axios from 'axios';
import { API_URL } from '../config/axiosConfig';

export const apiCreateCustomer = (payload, token) =>
  axios.post(`${API_URL}/v1/customers/add`, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

export const apiGetCustomer = (token) =>
  axios.get(`${API_URL}/v1/customers/all`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
export const apiGetCustomerTableListing = (token) =>
  axios.get(`${API_URL}/v1/customers/list/all`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
export const apiGetUnassignedCustomer = (token) =>
  axios.get(`${API_URL}/v1/customers/unassigned`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

export const apiGetCustomerById = (token, id) =>
  axios.get(`${API_URL}/v1/customers/id/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

export const apiUpdateCustomer = (token, payload) =>
  axios.put(`${API_URL}/v1/customers/update`, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

export const apiAssignCollector = (token, payload) =>
  axios.post(`${API_URL}/v1/users/assignCustomers`, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

export const apiGetLast5TransactionCustomer = (token, id) =>
  axios.get(`${API_URL}/v1/transaction/history/customerId/${id}/last/5`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
export const apiGetAllTransactionCustomerById = (token, id) =>
  axios.get(`${API_URL}/v1/transaction/history/customerId/${id}/all`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
